import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { clientMutation } from 'Core/data/GraphQLApi';
import { endpoints } from 'Core/defaultValues';
import { ExceptionManager } from 'Core/logManager';

const SLICE_NAME = 'dealers/views/.components/webHooksTab/redux';

const INIT_STATE = {
    toggleLoading: false,
};

export const toggleDealerWebhookStatus = createAsyncThunk(
    `${SLICE_NAME}/toggleDealerWebhookStatus`,
    async (payload, { rejectWithValue }) => {
        try {
            const { dealerId, webhookId, currentStatus } = payload;
            const newStatus = currentStatus === 1 ? 0 : 1;

            const response = await clientMutation(
                `mutation updateDealerWebhook($dealerId: Int!, $id: Int!, $status: Int) {
                    result: updateDealerWebhook(dealerId: $dealerId, id: $id, status: $status) {
                        id dealerId name url eventType status createdBy createdOn updatedBy updatedOn
                    }
                }`,
                { dealerId, id: webhookId, status: newStatus },
                endpoints.GRAPHQL_GENERAL
            );

            return { webhook: response?.result, success: !!response?.result };
        } catch (exc) {
            ExceptionManager(exc, `${SLICE_NAME}/toggleDealerWebhookStatus`, 'toggleDealerWebhookStatus');
            return rejectWithValue(exc.message || 'Failed to toggle webhook status');
        }
    }
);

export const webHooksTabSlice = createSlice({
    name: SLICE_NAME,
    initialState: INIT_STATE,
    reducers: {
        reset(state) {
            return { ...INIT_STATE };
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(toggleDealerWebhookStatus.pending, (state) => {
                state.toggleLoading = true;
            })
            .addCase(toggleDealerWebhookStatus.fulfilled, (state) => {
                state.toggleLoading = false;
            })
            .addCase(toggleDealerWebhookStatus.rejected, (state) => {
                state.toggleLoading = false;
            });
    }
});

export const { reset } = webHooksTabSlice.actions;
export default webHooksTabSlice.reducer;
